var _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask2, _g2, _path8, _path9, _path10, _path11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoOverauto = function SvgLogoOverauto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 41,
    viewBox: "0 0 175 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H33.7131V33.5106H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2588 20.3778C14.5735 20.3778 17.6487 21.6057 17.6487 23.1196C17.6487 24.6313 15.7701 25.2563 13.455 25.2563C11.1383 25.2563 9.25972 24.6313 9.25972 23.1196C9.25972 21.6057 9.94168 20.3778 12.2588 20.3778ZM19.6993 0C17.2657 0 14.9854 0.891258 13.4429 2.44533C10.5009 5.41097 8.432 8.12218 6.99384 10.898L6.13368 10.2168C5.89568 10.035 5.60101 9.93679 5.29775 9.94061H1.2068C0.540874 9.94061 0 10.3872 0 10.9358V13.2428C0 13.7696 0.495931 14.204 1.13099 14.2384L5.33683 14.4565C4.70177 15.9865 4.20389 18.2691 4.20389 21.4872C4.20389 24.2791 4.88193 26.1131 6.05786 27.3009V32.6774C6.05786 33.1382 6.51041 33.5106 7.06965 33.5106H11.7241C12.2834 33.5106 12.7359 33.1382 12.7359 32.6774V29.3393L29.1634 29.3344C28.1758 27.9767 27.3219 26.5078 26.6724 24.9415H23.4932C22.1676 24.9415 21.0882 24.0506 21.0882 22.9573C21.121 22.6249 21.42 22.3762 21.762 22.4026L25.8099 22.4068C25.3183 20.6139 25.0521 18.726 25.0521 16.7815C25.0521 14.6444 25.4613 12.5682 26.0491 10.6195L12.0806 10.6336C13.2706 8.75901 14.8564 6.83285 16.8968 4.77413C17.6425 4.05517 18.6523 3.66054 19.6993 3.67849L29.8309 3.68499C30.8876 2.32079 32.361 1.07921 33.7132 0H19.6993Z",
    fill: "#4A5560"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0062 19.1892C77.0062 16.417 74.9287 14.5692 72.4846 14.5692C70.0409 14.5692 67.9938 16.417 67.9938 19.1892C67.9938 21.992 70.0409 23.8708 72.4846 23.8708C74.9287 23.8708 77.0062 21.992 77.0062 19.1892ZM65 19.1892C65 14.6306 68.4214 11.7354 72.4846 11.7354C76.5478 11.7354 80 14.6306 80 19.1892C80 23.7478 76.5478 26.7354 72.4846 26.7354C68.4214 26.7354 65 23.7478 65 19.1892Z",
    fill: "#4A5560"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 12.7354L87.9444 26.7354H85.056L79 12.7354H82.2609L86.4847 22.9281L90.7082 12.7354H94Z",
    fill: "#4A5560"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.111 18.2815C104.846 16.1006 103.254 14.9059 101.132 14.9059C99.0107 14.9059 97.4186 15.9813 97.0063 18.2815H105.111ZM99.4229 10.3955L96.1811 5.73535H98.6861L100.897 8.334L103.107 5.73535H105.642L102.4 10.3955H99.4229ZM107.941 20.6411H96.9766C97.3599 22.9115 99.0107 24.017 101.25 24.017C102.842 24.017 104.345 23.3297 105.111 22.0454L107.41 23.2104C106.202 25.5403 103.726 26.7354 101.103 26.7354C97.1241 26.7354 94 23.8375 94 19.4167C94 14.9955 97.1827 12.1876 101.103 12.1876C105.023 12.1876 108 14.9955 108 19.3866C108 19.775 107.97 20.1936 107.941 20.6411Z",
    fill: "#4A5560"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 12.7958L118.507 15.6141C117.753 15.2506 117.058 15.1292 116.507 15.1292C114.043 15.1292 112.884 17.8264 112.884 21.6444V26.7354H110.015V12.5839H112.884V15.7657C113.58 13.2811 114.942 12.2807 116.681 12.2807C117.608 12.2807 118.565 12.5236 119 12.7958ZM112.188 10.4628L109 5.73535H111.463L113.637 8.3719L115.811 5.73535H118.304L115.116 10.4628H112.188Z",
    fill: "#4A5560"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.975 19.1892C130.975 16.2943 128.623 14.5999 126.424 14.5999C123.98 14.5999 121.994 16.4787 121.994 19.1892C121.994 21.8686 123.98 23.8708 126.424 23.8708C128.837 23.8708 130.975 22.0844 130.975 19.1892ZM134 12.0435V26.4272H131.006V24.2713C130.059 25.9037 128.012 26.7354 126.088 26.7354C122.208 26.7354 119 23.7788 119 19.2198C119 14.6306 122.208 11.7354 126.057 11.7354C128.073 11.7354 130.059 12.5364 131.006 14.1691V12.0435H134Z",
    fill: "#4A5560"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 11.7354V26.4207H146.085V24.1879C145.282 25.9805 143.05 26.7354 141.593 26.7354C138.083 26.7354 135.971 24.3139 136 20.1316V11.7354H138.916V19.9113C138.916 22.301 140.284 23.6847 142.069 23.6847C143.883 23.6847 146.085 22.6157 146.085 19.5967V11.7354H149Z",
    fill: "#4A5560"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 15.3415H156.809V26.7354H153.681V15.3415H151V12.9147H153.681V7.73535H156.809V12.9147H160V15.3415Z",
    fill: "#4A5560"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 12,
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.093 12.0801H174.891V26.3912H160.093V12.0801Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.937 19.1916C171.937 16.5467 169.888 14.7838 167.476 14.7838C165.066 14.7838 163.046 16.5467 163.046 19.1916C163.046 21.8657 165.066 23.6582 167.476 23.6582C169.888 23.6582 171.937 21.8657 171.937 19.1916ZM160.093 19.1916C160.093 14.8423 163.468 12.0801 167.476 12.0801C171.485 12.0801 174.891 14.8423 174.891 19.1916C174.891 23.5408 171.485 26.3912 167.476 26.3912C163.468 26.3912 160.093 23.5408 160.093 19.1916Z",
    fill: "#4A5560"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 17.2354C61 26.3479 53.389 33.7354 44.0002 33.7354C34.6114 33.7354 27 26.3479 27 17.2354C27 8.12281 34.6114 0.735352 44.0002 0.735352C53.389 0.735352 61 8.12281 61 17.2354Z",
    fill: "#1780FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.942 34.5722L58.1063 25.7354C56.7898 27.783 55.0475 29.5245 53 30.8411L61.8365 39.6779C63.2471 41.0878 65.5344 41.0878 66.942 39.6779C68.3527 38.2695 68.3527 35.9825 66.942 34.5722Z",
    fill: "#1780FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 27.2351C38.21 27.2351 33.5002 22.5257 33.5002 16.7355C33.5002 10.9454 38.21 6.23559 44 6.23559C49.79 6.23559 54.5002 10.9454 54.5002 16.7355C54.5002 22.5257 49.79 27.2351 44 27.2351ZM58 16.7352C58 9.00398 51.7315 2.73535 44 2.73535C36.2685 2.73535 30 9.00398 30 16.7352C30 24.4671 36.2685 30.7354 44 30.7354C51.7315 30.7354 58 24.4671 58 16.7352Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 16.7354H38.2853C38.2853 13.5849 40.8494 11.0213 44 11.0213V8.73535C39.5895 8.73535 36 12.3247 36 16.7354Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoOverauto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-overauto.536c2557.svg";
export { ForwardRef as ReactComponent };